﻿import { defineComponent } from "/Scripts/vue.esm-browser.js";

const html = String.raw;

export default defineComponent({
    name: "FooterBottom",

    props: {
        webSite: {
            type: String,
            required: true,
        },
    },
    components: {},
    setup() {
        return {};
    },
    template: html`
        <div class="footer_bottom" v-if="webSite!='bbc'">
            <a
                class="fl_r"
                href="/Company/Policy"
                target="_blank"
                rel="noopener noreferrer"
            >
                隱私權政策
            </a>
            <a
                class="fl_r"
                href="//www.104.com.tw/jobbank/custjob/index.php?r=cust&amp;j=483a446d5a46406a30683b1d1d1d1d5f2443a363189j56&amp;jobsource=checkc"
                target="_blank"
                rel="noopener noreferrer"
            >
                菁英招募
            </a>
            <a
                class="fl_r"
                href="//www.facebook.com/BWT.voyage/"
                target="_blank"
                rel="noopener noreferrer"
            >
                FB粉絲團
            </a>

            <div class="copyright">© 2015 百威旅行社股份有限公司 版權所有</div>
        </div>
    `,
});
